// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","CategoriesList":"bh_a bhc_ea bhc_kb bhc_js bhc_wj"};